import { API_ENDPOINTS } from '../endpoints';
import { getAuthHeaders, handleResponse } from '../client';
import type { IpcCascadeVO, IpdCascadeVO, KeyNodeMappingSaveDTO, KeyNodeMappingVO, KeyNodeSaveDTO, KeyNodeVO, PageResponse } from '../types';

export const keyNodeApi = {
  getList: async (params?: {
    keyword?: string;
    monitorEnabled?: number;
    mappingStatus?: string;
    pageNum?: number;
    pageSize?: number;
  }): Promise<PageResponse<KeyNodeVO>> => {
    const queryParams = new URLSearchParams();
    if (params?.keyword) queryParams.append('Keyword', params.keyword);
    if (params?.monitorEnabled != null) queryParams.append('MonitorEnabled', String(params.monitorEnabled));
    if (params?.mappingStatus) queryParams.append('MappingStatus', params.mappingStatus);
    queryParams.append('PageNum', String(params?.pageNum ?? 1));
    queryParams.append('PageSize', String(params?.pageSize ?? 9999));

    const response = await fetch(`${API_ENDPOINTS.KEY_NODE.LIST}?${queryParams}`, {
      headers: getAuthHeaders(),
    });
    return handleResponse<PageResponse<KeyNodeVO>>(response);
  },

  getById: async (id: number): Promise<KeyNodeVO> => {
    const response = await fetch(API_ENDPOINTS.KEY_NODE.DETAIL(id), {
      headers: getAuthHeaders(),
    });
    return handleResponse<KeyNodeVO>(response);
  },

  create: async (data: KeyNodeSaveDTO): Promise<KeyNodeVO> => {
    const response = await fetch(API_ENDPOINTS.KEY_NODE.CREATE, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return handleResponse<KeyNodeVO>(response);
  },

  update: async (id: number, data: KeyNodeSaveDTO): Promise<boolean> => {
    const response = await fetch(API_ENDPOINTS.KEY_NODE.UPDATE(id), {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return handleResponse<boolean>(response);
  },

  delete: async (id: number): Promise<boolean> => {
    const response = await fetch(API_ENDPOINTS.KEY_NODE.DELETE(id), {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    await handleResponse<unknown>(response);
    return true;
  },

  toggle: async (id: number, field: string, value: number): Promise<KeyNodeVO> => {
    const response = await fetch(API_ENDPOINTS.KEY_NODE.TOGGLE(id), {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify({ field, value }),
    });
    return handleResponse<KeyNodeVO>(response);
  },

  getMappings: async (id: number): Promise<KeyNodeMappingVO[]> => {
    const response = await fetch(API_ENDPOINTS.KEY_NODE.MAPPINGS(id), {
      headers: getAuthHeaders(),
    });
    return handleResponse<KeyNodeMappingVO[]>(response);
  },

  saveMappings: async (id: number, data: KeyNodeMappingSaveDTO): Promise<boolean> => {
    const response = await fetch(API_ENDPOINTS.KEY_NODE.MAPPINGS(id), {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return handleResponse<boolean>(response);
  },

  getCascadeIpd: async (): Promise<IpdCascadeVO[]> => {
    const response = await fetch(API_ENDPOINTS.KEY_NODE.CASCADE_IPD, {
      headers: getAuthHeaders(),
    });
    return handleResponse<IpdCascadeVO[]>(response);
  },

  getCascadeIpc: async (): Promise<IpcCascadeVO[]> => {
    const response = await fetch(API_ENDPOINTS.KEY_NODE.CASCADE_IPC, {
      headers: getAuthHeaders(),
    });
    return handleResponse<IpcCascadeVO[]>(response);
  },
};
